import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store/index';
import App from './App';
import './styles/global.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// CLAUDE-SYNC: v1.7.12 (2026-09-02) — PWA install support. register() only
// takes effect in a production build (see serviceWorkerRegistration.js),
// so this is a no-op in local dev.
serviceWorkerRegistration.register();
